import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

import { Card, Typography, Box, Button } from '@material-ui/core'

export const TaskListContainer = styled(Card)`
  background-color: transparent;
  box-shadow: none;
`

export const Header = styled(Typography)`
  ${typography.up1.regularSerif}
  align-items: center;
  display: flex;
`

export const HeaderContainer = styled(Box)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
  width: 100%;
`

export const Title = styled(Typography)`
  font-weight: 600;
`

export const TaskItemsContainer = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  box-shadow: 2px 4px 8px 0 rgba(0, 50, 99, 0.07);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`

export const ViewMoreOrLessButton = styled(Button)`
  margin-top: 16px;
  padding: 8px 16px;
`
